import React, {useState, useEffect} from "react";
import { GetCoponByIdData} from "../../../lib/data";
import { useParams } from "react-router-dom";
import i18n from "../../../lib/i18n";
import { statusOfCopons } from "../../../lib/definitions";
import EditCoponsUi from "../../../ui/coponUi/editCoponUi";

export default function EditCopons () {

    const [coponsData, setCoponsData] = useState({});
    const {coponId} = useParams();
    const t = i18n.t.bind(i18n); 
    
    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const coponData = await GetCoponByIdData(coponId);
        setCoponsData({});        
        setCoponsData(coponData.data);
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.copons")}</h1>
                <EditCoponsUi statusOfCopons={statusOfCopons} coponsData={coponsData} />
            </div>
        </div>
    );
};